import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    user: any = {
        id: null,
        authorities: [],
        dateOfBirth: '',
        email: '',
        firstName: '',
        lastName: '',
        langKey: 'en',
        login: '',
        role: 0,
        routeRole: '',
        organisation: ''
    };
    store: any = {
        id: null,
        name: ''
    }



    currencies: any = [
        { name: 'British Pounds', value: 'GBP' },
        { name: 'Euro', value: 'EUR' },
        { name: 'US Dollar', value: 'USD' },
    ];


    daysOfWeek: any = [
        { name: 'Monday', value: 1 },
        { name: 'Tuesday', value: 2 },
        { name: 'Wednesday', value: 3 },
        { name: 'Thursday', value: 4 },
        { name: 'Friday', value: 5 },
        { name: 'Saturday', value: 6 },
        { name: 'Sunday', value: 0 },
    ];

    dayHours: any = [
        { name: '1 am', value: '01' }, { name: '2 am', value: '02' }, { name: '3 am', value: '03' }, { name: '4 am', value: '04' },
        { name: '5 am', value: '05' }, { name: '6 am', value: '06' }, { name: '7 am', value: '07' }, { name: '8 am', value: '08' },
        { name: '9 am', value: '09' }, { name: '10 am', value: '10' }, { name: '11 am', value: '11' }, { name: '12 noon', value: '12' },
        { name: '1 pm', value: '13' }, { name: '2 pm', value: '14' }, { name: '3 pm', value: '15' }, { name: '4 pm', value: '16' },
        { name: '5 pm', value: '17' }, { name: '6 pm', value: '18' }, { name: '7 pm', value: '19' }, { name: '8 pm', value: '20' },
        { name: '9 pm', value: '21' }, { name: '10 pm', value: '22' }, { name: '11 pm', value: '23' }, { name: 'Midnight', value: '00' },
    ]

    hourMins: any = [
        { value: '00' }, { value: '05' }, { value: '10' }, { value: '15' }, { value: '20' },
        { value: '25' }, { value: '30' }, { value: '35' }, { value: '40' }, { value: '45' },
        { value: '50' }, { value: '55' },
    ]

    customMapStyle: [
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#e9e9e9'
                }, {
                    'lightness': 17
                }
            ]
        }, {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f5f5f5'
                }, {
                    'lightness': 20
                }
            ]
        }, {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#ffffff'
                }, {
                    'lightness': 17
                }
            ]
        }, {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#ffffff'
                }, {
                    'lightness': 29
                }, {
                    'weight': 0.2
                }
            ]
        }, {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#ffffff'
                }, {
                    'lightness': 18
                }
            ]
        }, {
            'featureType': 'road.local',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#ffffff'
                }, {
                    'lightness': 16
                }
            ]
        }, {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f5f5f5'
                }, {
                    'lightness': 21
                }
            ]
        }, {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#dedede'
                }, {
                    'lightness': 21
                }
            ]
        }, {
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'on'
                }, {
                    'color': '#ffffff'
                }, {
                    'lightness': 16
                }
            ]
        }, {
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'saturation': 36
                }, {
                    'color': '#333333'
                }, {
                    'lightness': 40
                }
            ]
        }, {
            'elementType': 'labels.icon',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        }, {
            'featureType': 'transit',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#f2f2f2'
                }, {
                    'lightness': 19
                }
            ]
        }, {
            'featureType': 'administrative',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#fefefe'
                }, {
                    'lightness': 20
                }
            ]
        }, {
            'featureType': 'administrative',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#fefefe'
                }, {
                    'lightness': 17
                }, {
                    'weight': 1.2
                }
            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./src/app/_globals.ts